import React, { Dispatch, SetStateAction } from 'react';
import TextareaAutosize from 'react-textarea-autosize';

import { StateLanguage } from '../../../../../languages/config/StateLanguage';
import { Category } from '../../../../../models/category.model';
import { evaluateLegendValidRequired, evaluateLegendValidRequiredIcon } from '../../../../../scripts/validate.legend.script';
import { expressions } from '../../../../../libraries/regular.expressions.library';
import { prefixLegend } from '../../../../../scripts/name.legend.script';

import AppLegend from '../../../../../components/element/Legend';
import AppInventoryFormAccountingAccount from '../../component/InventoryFormAccountingAccount';
import AppInventoryFormName from '../../component/InventoryFormName';

export interface AppCategoryFormProps {
  component?: string,
  category?: Category,
  name: {value: string, valid: boolean},
  description: {value: string, valid: boolean},
  names: {value: {en: string, fr: string, it: string, de: string}, valid: {en: boolean, fr: boolean, it: boolean, de: boolean}},
  accounts: {value: {expense: string, vat: string, product: string}, valid: {expense: boolean, vat: boolean, product: boolean}},
  setName: Dispatch<SetStateAction<{value: string, valid: boolean}>>,
  setDescription: Dispatch<SetStateAction<{value: string, valid: boolean}>>,
  setNames: Dispatch<SetStateAction<{value: {en: string, fr: string, it: string, de: string}, valid: {en: boolean, fr: boolean, it: boolean, de: boolean}}>>,
  setAccounts: Dispatch<SetStateAction<{value: {expense: string, vat: string, product: string}, valid: {expense: boolean, vat: boolean, product: boolean}}>>
};

const AppCategoryForm: React.FunctionComponent<AppCategoryFormProps> = ({component, category, name, description, names, accounts, setName, setDescription, setNames, setAccounts}) => {
  const {lang} = StateLanguage()

  const handleChangeName = (event: React.ChangeEvent <HTMLFormElement | HTMLInputElement>) => {
    setName({...name, value: event.target.value})
  }

  const handleChangeDescription = (event: React.ChangeEvent <HTMLFormElement | HTMLTextAreaElement>) => {
    setDescription({...description, value: event.target.value})
  }

  const validateName = () => {
    evaluateLegendValidRequiredIcon(expressions.name, name, setName, `${prefixLegend(component)}input-name`, `${prefixLegend(component)}legend-name-valid`, `${prefixLegend(component)}legend-name-required`)
  }

  const validateDescription = () => {
    evaluateLegendValidRequired(expressions.text, description, setDescription, `${prefixLegend(component)}legend-description-valid`, `${prefixLegend(component)}legend-description-required`)
  }

  return (
    <div className="form d-flex flex-column flex-lg-row">
      <div className="d-flex flex-column w-100 w-lg-350px order-2 order-lg-1">
        <AppInventoryFormName component={component} action={category ? "update" : "create"} names={names} setNames={setNames}></AppInventoryFormName>
      </div>
      <div className="d-flex flex-column flex-row-fluid order-1 order-lg-2">
        <div className="card card-flush">
          <div className="card-header">
            <div className="card-title">
              <h3>{lang.labels.general}</h3>
            </div>
          </div>
          <div className="card-body pt-0">
            <div className="fv-row mb-3">
              <label className="form-label required">{lang.labels.categoryName}</label>
              <input id={`${prefixLegend(component)}input-name`} className="form-control form-control-solid" type="text" autoComplete="off" name="name" value={name.value} onChange={handleChangeName} onKeyUp={validateName} onBlur={validateName} />
              <AppLegend component={component} attribute={{check: name.valid, name: "name", index: null, sub_index: null}} container={{valid: true, required: true, identical: false, exists: false}}></AppLegend>
            </div>
            <div className="fv-row mb-3">
              <label className="required form-label">{lang.labels.description}</label>
              <TextareaAutosize className="form-control form-control-solid" minRows={2} maxRows={3} name="description" value={description.value} onChange={handleChangeDescription} onKeyUp={validateDescription} onBlur={validateDescription} />
              <AppLegend component={component} attribute={{check: description.valid, name: "description", index: null, sub_index: null}} container={{valid: true, required: true, identical: false, exists: false}}></AppLegend>
            </div>
            <AppInventoryFormAccountingAccount component={component} accounts={accounts} setAccounts={setAccounts}></AppInventoryFormAccountingAccount>
          </div>
        </div>
      </div>
    </div>
  )
};

export default AppCategoryForm;
